<template>
  <div class="modal fade viewTicketModal" :id="id" tabindex="-1" role="dialog" aria-labelledby="viewTicketModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ parentTaskDetails.mainText ? parentTaskDetails.mainText : '' }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-10 pb-10">
          <ul class="pl-0" style="list-style-type:none;">
            <li><b>Service type: </b><span class="badge badge-info">{{parentTaskDetails.serviceType}}</span></li>
            <li><b>Domain: </b>{{ parentTaskDetails.domain }}</li>
            <li class="mt-8"><b>Ticket URL: </b><a :href="parentTaskDetails.ticketURL" target="_blank">{{parentTaskDetails.ticketURL}}</a></li>
            <li class="mt-8"><b>Task Type: </b>{{ parentTaskDetails.taskType }}</li>
            <li class="mt-8"><b>Priority: </b>{{ parentTaskDetails.priority }}</li>
            <li class="mt-8"><b>Assign: </b>{{ parentTaskDetails.assign === undefined ? "none" : parentTaskDetails.assign.name   }}</li>
            <li class="mt-8"><b>Client: </b>{{ parentTaskDetails.hostBillID ? parentTaskDetails.hostBillID : 'none'  }}</li>
            <li class="mt-8"><b>Service Id: </b>{{ parentTaskDetails.hbServiceId && parentTaskDetails.hbServiceId.length ? parentTaskDetails.hbServiceId.toString() : 'none' }}</li>
            <li class="mt-8"><b>Comments: </b>{{ parentTaskDetails.comment }}</li>
            <li class="mt-8"><b>Task Created At: </b>{{ parentTaskDetails.createdAt | formatTimeFirst}}</li>
            <li class="mt-8"><b>Task Created By: </b>{{ parentTaskDetails.createdBy }}</li>
          </ul>
          <div class="row">
            <div class="col-md-12">
              <div v-if="parentTaskDetails.taskList && parentTaskDetails.taskList.length && this.showTaskList">
                <b>Task List:</b>
                <perfect-scrollbar class="scroll-area">
                  <div class="container">
                    <ul style="height: 200px" class="list-group">
                      <li v-for="(row, index) in taskList" :key="index" class="list-group-item border-0">
                        <div class="row">
                          <div class="col-md-8 d-flex align-items-center">
                            <input class="form-check-input" type="checkbox" v-model="row.isChecked" @change="checkTask(row)" :disabled="disabledForCheckedUser(row)"/>
                            <div class="ml-2 mt-5">{{row.text}}</div>
                          </div>
                          <div class="col-md-4 d-flex align-items-center" v-if="row.isChecked">
                            <span  class="badge badge-pill badge-success"> checkin by :{{row.checkedBy}} </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </perfect-scrollbar>
                <button v-if="!showRemainingTaskList && parentTaskDetails.taskList && parentTaskDetails.taskList.length > 3" @click="showRemaining()" type="button" style="background-color: #f1f2f4; color: #5c6a82" class="btn btn-md btn-block mt-15">View Remaining Task List</button>
                <button v-else-if="showRemainingTaskList" @click="showRemainingTaskList = false;" style="  background-color: #f1f2f4 !important; color: #5c6a82 !important;" type="button" class="btn btn-md btn-block mt-15 secondary">Minimize Task List</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer pt-0 pb-0">
          <button @click="showRemainingTaskList=false" type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import {db} from "@/firebase/init";
export default {
  name: "ManualTaskDetailModal",
  components: {PerfectScrollbar},
  props: {
    parentTaskDetails: {
      type: Object
    },
    showTaskList:{
      type: Boolean,
      default: true,
    },
    id:{
      type: String
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    taskList() {
      let taskList = JSON.parse(JSON.stringify(this.parentTaskDetails.taskList));
      if(!this.showRemainingTaskList) {
        taskList = taskList.splice(0,3)
      }
      return taskList
    }
  },
  data(){
    return {
      showRemainingTaskList: false
    }
  },
  methods: {
    showRemaining(){
      this.showRemainingTaskList = true;
    },
    disabledForCheckedUser(row){
      if(row.isChecked && row.checkedById === this.user.uid){
        return false
      }
      else if(!row.isChecked){
        return false
      }
      else{
        return true
      }

    },
    async checkTask(row){
      try{
        if(row.isChecked){
          row.checkedById= this.user.uid
          row.checkedBy= `${this.user.firstName} ${this.user.lastName}`
        }
        else{
          row.checkedById= false
          row.checkedBy= false
        }
        await db.collection('manualTasks').doc(this.parentTaskDetails.id).update({ taskList: this.parentTaskDetails.taskList})
      }
      catch(e){
        console.log('Error While Updating task List')
      }
    },

  }

}
</script>
